<div class="expanding-menu-header">
  <button class="home-btn" (click)="homeSelect.emit()">
    <icon name="home_menu_alt"></icon>
  </button>

  <h4>{{headerText}}</h4>
  @if (showBackBtn) {
    <button class="back-btn" (click)="handleBackButton()">
      <icon name="back_arrow"></icon>
    </button>
  }

  <button class="expand-collapse-btn" (click)="toggleMenuExpandCollapse()">
    @if ((menuService.isExpanded$ | async) === false) {
      <icon name="menu_expand"></icon>
    }
    @if (menuService.isExpanded$ | async) {
      <icon name="menu_collapse"></icon>
    }
  </button>
</div>
<div class="expanding-menu-body">
  <ng-content></ng-content>
</div>

@if (canScrollRight) {
  <div class="scroll-right-shadow"></div>
}
@if (canScrollLeft) {
  <div class="scroll-left-shadow"></div>
}